import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import styles from "./ModalProduct.module.sass";
import Icon from "../Icon";

const ModalProduct = ({ item, visible, onClose }) => {
	useEffect(() => {
		if (visible) {
			const target = document.querySelector("#modal-product");
			disableBodyScroll(target);
		} else {
			clearAllBodyScrollLocks();
		}
	}, [visible]);

	return createPortal(
		visible && (
			<div id="modal-product" className={styles.modal}>
				<div className={styles.control}>
					<button className={styles.close} onClick={onClose}>
						<Icon name="close" size="20" />
					</button>
				</div>
				<div className={styles.outer}>
					{/* <Product /> */}
					<iframe
						frameBorder={0}
						className={styles.iframe}
						title={item._id}
						src={"https://brandbox-frontend.vercel.app/collections/" + item._id}
					></iframe>
				</div>
			</div>
		),
		document.body
	);
};

export default ModalProduct;
